import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useDomainServices } from "@/providers/DomainServices";

import { AgentRecord, UpdateAgentRequest } from "../AgentRecord";

import { agentQueryKey } from "./useAgent";

interface UpdateAgentParams {
  orgId: string;
  agentId: string;
  request: UpdateAgentRequest;
}

/**
 * Mutation hook for updating an agent.
 *
 * Invalidates both the list query (agents table) and the per-agent
 * query (detail/editor page) so all consumers refetch after a successful
 * write.
 */
export function useUpdateAgent() {
  const { agentService } = useDomainServices();
  const queryClient = useQueryClient();

  return useMutation<AgentRecord, Error, UpdateAgentParams>({
    mutationFn: ({ orgId, agentId, request }) =>
      agentService.updateAgent(agentId, request, { orgId }),
    onSuccess: (_, { agentId }) => {
      void queryClient.invalidateQueries({ queryKey: ["agents"] });
      void queryClient.invalidateQueries({
        queryKey: agentQueryKey(agentId),
      });
    },
  });
}
